<ng-container *ngIf="jobDetails && !loading">
  <mat-card class="job-card">
    <mat-card-header>
      <div class="CViewHeading_Container">
        <div class="left-section">
          <button mat-icon-button (click)="goBack()" aria-label="Back">
            <i class="fa-solid fa-arrow-left"></i>
          </button>

          <div class="title-subtitle">
            <mat-card-title>{{ jobDetails.position_name }}</mat-card-title>
            <mat-card-subtitle>
              <span class="department">{{ jobDetails.department_name }}</span>
              <span
                class="status"
                [class.active]="jobDetails.status === 'ACTIVE'"
              >
                {{ jobDetails.status }}
              </span>
            </mat-card-subtitle>
          </div>
        </div>
      </div>
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content>
      <div class="job-meta">
        <div class="meta-item">
          <i class="fa-solid fa-location-dot"></i>
          <span>{{ jobDetails.location }}</span>
        </div>
        <div class="meta-item">
          <i class="fa-solid fa-briefcase"></i>
          <span>{{ getEmploymentType(jobDetails.employment_type_id) }}</span>
        </div>
        <div class="meta-item">
          <i class="fa-regular fa-clock"></i>
          <span>{{ jobDetails.experience_in_years }} <span translate>years experience</span></span>
        </div>
        <div class="meta-item">
          <i class="fa-solid fa-users"></i>
          <span>{{ jobDetails.number_of_openings }} <span translate>openings</span></span>
        </div>
        <div class="meta-item">
          <i class="fa-solid fa-indian-rupee-sign"></i>
          <span>{{ jobDetails.salary }}</span>
        </div>
      </div>

      <div class="section">
        <h3 translate>Job Description</h3>
        <p>{{ jobDetails.company_profile }}</p>

        <!-- JD File Content Section -->
        <div class="jd-content">
          <h4 translate>Detailed Job Description</h4>

          <div *ngIf="jdLoading" class="loading-jd">
            <mat-spinner diameter="30"></mat-spinner>
            <span translate>Loading job description...</span>
          </div>

          <div *ngIf="jdError" class="jd-error">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span>{{ jdError }}</span>
          </div>

          <pre *ngIf="jdContent && !jdLoading">{{ jdContent }}</pre>
        </div>
      </div>

      <div class="section" *ngIf="jobDetails.skills?.skills?.length">
        <h3 translate>Required Skills</h3>
        <mat-chip-listbox>
          <mat-chip *ngFor="let skill of jobDetails.skills.skills">
            {{ skill }}
          </mat-chip>
        </mat-chip-listbox>
      </div>

      <div class="section contact-info">
        <h3 translate>Contact Information</h3>
        <div class="contact-item">
          <i class="fa-solid fa-envelope"></i>
          <a [href]="'mailto:' + jobDetails.email">{{ jobDetails.email }}</a>
        </div>
        <div class="contact-item">
          <i class="fa-solid fa-phone"></i>
          <a [href]="'tel:' + jobDetails.phone_number">
            {{ jobDetails.phone_number }}
          </a>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>
